import { FlowConfig } from '../classes/flow-config/flow-config';
import { IntegrationStage } from '../enums/integration-stage';

export const restAPIPrefix = 'Rest';
export const hubSpotWebhookPrefix = 'HubSpotWebhook';
export const hubSpotPrefix = 'HubSpot';
export const salesforcePrefix = 'Salesforce';
export const shopifyWebhookPrefix = 'ShopifyWebhook';
export const shopifyPrefix = 'Shopify';
export const dbConnectorPrefix = 'DatabaseConnector';
export const sftpConnectorPrefix = 'SFTPConnector';
export const fileReaderPrefix = 'FileReader';
export const fileWriterPrefix = 'FileWriter';
export const s3ConnectorPrefix = 'S3Connector';
export const flowPartWildCard = '{FLOWPART}';

export function ReplaceFlowPart(url: string, flowConfig: FlowConfig, prefix: string) {
	if (!url.includes(flowPartWildCard)) return url;
	const actualURL =
		flowConfig.type === 'Integration'
			? `${prefix}/${flowConfig.name}/${IntegrationStage[flowConfig.stage]}/${flowConfig.version}`
			: `${prefix}/${flowConfig.name}/${flowConfig.version}`;
	url = url.replace(flowPartWildCard, actualURL).replaceAll(` `, '-');
	return url;
}
